// ─── S&OP Platform Mock Data ─────────────────────────────────────────────────

export const SKU_DATA = [
  { id: "SKU-001", name: "Vitamin C Serum 30ml", stock: 4200, velocity: 85, dos: 49, status: "healthy", fc: 2550, margin: 0.62, ch: "Shopee" },
  { id: "SKU-002", name: "Hyaluronic Acid Toner 150ml", stock: 890, velocity: 72, dos: 12, status: "critical", fc: 2160, margin: 0.58, ch: "TikTok" },
  { id: "SKU-003", name: "SPF50 Sunscreen 50ml", stock: 6100, velocity: 45, dos: 135, status: "overstock", fc: 1350, margin: 0.55, ch: "DTC" },
  { id: "SKU-004", name: "Retinol Night Cream 50ml", stock: 2800, velocity: 63, dos: 44, status: "healthy", fc: 1890, margin: 0.67, ch: "Shopee" },
  { id: "SKU-005", name: "Niacinamide Serum 30ml", stock: 1100, velocity: 91, dos: 12, status: "critical", fc: 2730, margin: 0.61, ch: "TikTok" },
  { id: "SKU-006", name: "Cleansing Balm 100ml", stock: 3400, velocity: 38, dos: 89, status: "healthy", fc: 1140, margin: 0.54, ch: "Shopee" },
  { id: "SKU-007", name: "AHA/BHA Peel 30ml", stock: 5800, velocity: 22, dos: 263, status: "overstock", fc: 660, margin: 0.71, ch: "DTC" },
  { id: "SKU-008", name: "Centella Moisturizer 80ml", stock: 1950, velocity: 78, dos: 25, status: "warning", fc: 2340, margin: 0.59, ch: "TikTok" },
];

export const ALERTS = [
  { id: 1, type: "destructive", title: "OOS Risk: SKU-002 & SKU-005", desc: "TikTok channel inventory drops below safety stock in 12 days. Auto-generated PO #4821 pending Ops approval.", time: "12m", action: "Review PO", reasoning: "Based on 14-day rolling velocity (72 & 91 units/day) and current stock levels, both SKUs will stockout before next supplier delivery window (18 days). Recommended expedited order of 3,000 units each." },
  { id: 2, type: "warning", title: "Overstock Alert: SPF50 Sunscreen", desc: "135 days of stock. AI recommends markdown or channel reallocation to reduce carrying cost.", time: "1h", action: "View Options", reasoning: "Seasonal demand model predicts 40% velocity decline in next 60 days. Current stock of 6,100 units at $4.20/unit = $25,620 in tied-up capital. Recommended: allocate 2,000 units to Shopee flash sale." },
  { id: 3, type: "default", title: "Promotion Simulation Complete", desc: "TikTok 3.3 Sale scenario shows +38% revenue uplift with acceptable margin impact.", time: "2h", action: "View Results", reasoning: "Simulated 15% discount on top 5 SKUs across TikTok channel. Revenue uplift: +$42,300. Margin erosion: -3.2pp (from 61% to 57.8%). Net positive recommendation." },
  { id: 4, type: "success", title: "PO #4819 Confirmed by Supplier", desc: "2,500 units of Vitamin C Serum arriving Mar 8. Lead time within expected range.", time: "3h", action: "Track", reasoning: "Supplier confirmed standard lead time of 12 business days. ETA aligns with demand forecast buffer. No action required." },
  { id: 5, type: "warning", title: "Cash Flow Constraint Detected", desc: "Planned POs for next 2 weeks total $187K, exceeding weekly budget of $80K.", time: "4h", action: "Prioritize", reasoning: "Three POs scheduled within the same window: PO#4821 ($62K), PO#4822 ($48K), PO#4823 ($77K). Recommended priority: PO#4821 first, PO#4823 deferred." },
];

export const POS = [
  { id: "PO-4821", sup: "Guangzhou Beauty Co.", skus: ["SKU-002", "SKU-005"], units: 6000, cost: 62400, eta: "Mar 12", status: "pending", prio: "urgent", reasoning: "Critical OOS prevention. Both SKUs serve TikTok channel which has 3.3 sale event on Mar 15. Without this PO, estimated lost revenue: $89,000." },
  { id: "PO-4822", sup: "Shanghai Cosmetics Ltd.", skus: ["SKU-008"], units: 4000, cost: 48000, eta: "Mar 15", status: "pending", prio: "high", reasoning: "SKU-008 at 25 days of stock with accelerating velocity (+12% WoW). TikTok live stream scheduled Mar 10 expected to spike demand 2x." },
  { id: "PO-4823", sup: "Guangzhou Beauty Co.", skus: ["SKU-004", "SKU-006"], units: 5500, cost: 77000, eta: "Mar 18", status: "draft", prio: "medium", reasoning: "Replenishment order to maintain 45-day safety stock. Can be deferred 7 days without impact." },
  { id: "PO-4820", sup: "Korea Ingredients Inc.", skus: ["SKU-001"], units: 3000, cost: 34500, eta: "Mar 8", status: "approved", prio: "standard", reasoning: "Routine replenishment. Vitamin C Serum maintains healthy 49-day stock but velocity trending up +8% MoM." },
];

export const CAMPAIGNS = [
  { id: "C-101", name: "TikTok 3.3 Mega Sale", ch: "TikTok", status: "proposed", dates: "Mar 3–5", disc: "15%", rev: 152000, units: 4800, feas: "partial", note: "2 of 5 SKUs have insufficient stock" },
  { id: "C-102", name: "Shopee Payday Sale", ch: "Shopee", status: "approved", dates: "Mar 15–17", disc: "20%", rev: 98000, units: 3200, feas: "feasible", note: "All SKUs have adequate stock post-replenishment" },
  { id: "C-103", name: "DTC Bundle Promo", ch: "DTC", status: "simulating", dates: "Mar 20–31", disc: "B2G1", rev: 67000, units: 2100, feas: "feasible", note: "Helps reduce overstock on SPF50 and AHA/BHA Peel" },
];

export const SCENARIOS = [
  { id: "S1", name: "Conservative", rev: "1.82M", margin: "61.2%", cash: "340K", sla: "97%", risk: "Low", desc: "Maintain current velocities, no aggressive promos" },
  { id: "S2", name: "Base Case", rev: "2.14M", margin: "58.8%", cash: "420K", sla: "95%", risk: "Medium", desc: "Execute planned campaigns with standard discount levels" },
  { id: "S3", name: "Aggressive Growth", rev: "2.67M", margin: "54.1%", cash: "580K", sla: "92%", risk: "High", desc: "Deep discounts + expanded TikTok live + new SKU launch" },
];

export const AI_LOG = [
  { t: "08:00", a: "Demand forecast updated", d: "Incorporated 3.3 sale event uplift model. SKU-002 forecast revised +45% for Mar 1-7.", r: "Historical data shows 40-50% velocity spike for top skincare SKUs on TikTok. Applied bayesian adjustment with 0.85 confidence." },
  { t: "08:15", a: "Purchase plan generated", d: "Created PO-4821 for SKU-002 & SKU-005. Expedited timeline recommended.", r: "Gap analysis: SKU-002 needs 3,000 units by Mar 10. Current stock covers 12 days at current velocity, but sale will 1.45x velocity." },
  { t: "08:30", a: "Inventory reallocation", d: "Moved 500 units of SPF50 from DTC warehouse to Shopee fulfillment.", r: "DTC velocity 8 units/day vs Shopee 22 units/day. Transfer reduces overstock exposure by $2,100." },
  { t: "09:00", a: "Promotion simulation", d: "Completed 3 scenarios for TikTok 3.3 sale. Optimal: 15% discount on top 5 SKUs.", r: "15% maximizes revenue×margin product. 20% causes -7.2pp margin destruction without proportional volume uplift." },
  { t: "09:15", a: "Risk flag raised", d: "Cash flow constraint detected for next 2-week PO window.", r: "Sum of pending POs ($187K) exceeds 2-week budget ($160K). Prioritization matrix applied." },
  { t: "09:45", a: "Channel allocation updated", d: "Shifted 15% of SKU-004 allocation from DTC to TikTok.", r: "TikTok conversion rate up 23% this week. Reallocation maximizes revenue per unit by $1.40." },
];

// ─── Inventory Wireframe Data ────────────────────────────────────────────────

export const WAREHOUSES = [
  {
    id: "WH-01",
    name: "BoxMe 01",
    location: "HCMC VN",
    flag: "\u{1F1EE}\u{1F1E9}",
    type: "Primary",
    channels: ["Shopee", "TikTok", "DTC"],
    channelSplit: { Shopee: 45, TikTok: 35, DTC: 20 },
    channelColors: { Shopee: "#f97316", TikTok: "#ec4899", DTC: "#3b82f6" },
    skuCount: 62,
    totalUnits: 28400,
    cogValue: 812000,
    capacity: 72,
    status: "healthy",
    skus: [
      { id: "SKU-001", name: "Vitamin C Serum 30ml", stock: 4200, status: "healthy", velocity: 82, dos: 51, demandTrend: "growing", channelStock: { Shopee: 2520, TikTok: 1680 }, restockDays: { Shopee: 52, TikTok: 38 } },
      { id: "SKU-002", name: "Hyaluronic Acid Toner 150ml", stock: 890, status: "critical", velocity: 72, dos: 12, demandTrend: "growing", channelStock: { TikTok: 890 }, restockDays: { TikTok: 8 } },
      { id: "SKU-004", name: "Retinol Night Cream 50ml", stock: 2800, status: "healthy", velocity: 63, dos: 44, demandTrend: "stable", channelStock: { Shopee: 2800 }, restockDays: { Shopee: 44 } },
      { id: "SKU-005", name: "Niacinamide Serum 30ml", stock: 1100, status: "critical", velocity: 91, dos: 12, demandTrend: "growing", channelStock: { TikTok: 1100 }, restockDays: { TikTok: 7 } },
      { id: "SKU-008", name: "Centella Moisturizer 80ml", stock: 1950, status: "warning", velocity: 78, dos: 25, demandTrend: "slowing", channelStock: { TikTok: 1170, DTC: 780 }, restockDays: { TikTok: 18, DTC: 32 } },
    ],
  },
  {
    id: "WH-02",
    name: "BoxMe 02",
    location: "HCMC VN",
    flag: "\u{1F1EE}\u{1F1E9}",
    type: "Secondary",
    channels: ["Shopee", "Lazada"],
    channelSplit: { Shopee: 60, Lazada: 40 },
    channelColors: { Shopee: "#f97316", Lazada: "#a855f7" },
    skuCount: 34,
    totalUnits: 11200,
    cogValue: 334500,
    capacity: 55,
    status: "healthy",
    skus: [
      { id: "SKU-003", name: "SPF50 Sunscreen 50ml", stock: 6100, status: "overstock", velocity: 45, dos: 135, demandTrend: "slowing", channelStock: { Shopee: 3660, Lazada: 2440 }, restockDays: { Shopee: 110, Lazada: 145 } },
      { id: "SKU-006", name: "Cleansing Balm 100ml", stock: 3400, status: "healthy", velocity: 38, dos: 89, demandTrend: "stable", channelStock: { Shopee: 3400 }, restockDays: { Shopee: 82 } },
      { id: "SKU-007", name: "AHA/BHA Peel 30ml", stock: 5800, status: "overstock", velocity: 22, dos: 263, demandTrend: "slowing", channelStock: { Lazada: 5800 }, restockDays: { Lazada: 220 } },
    ],
  },
  {
    id: "WH-03",
    name: "Viettel Post",
    location: "HCMC VN",
    flag: "\u{1F1F8}\u{1F1EC}",
    type: "Cross-Border",
    channels: ["DTC", "TikTok", "B2B"],
    channelSplit: { DTC: 50, TikTok: 25, B2B: 25 },
    channelColors: { DTC: "#3b82f6", TikTok: "#ec4899", B2B: "#0d9488" },
    skuCount: 18,
    totalUnits: 5600,
    cogValue: 198000,
    capacity: 38,
    status: "warning",
    skus: [
      { id: "SKU-001", name: "Vitamin C Serum 30ml", stock: 1200, status: "healthy", velocity: 34, dos: 35, demandTrend: "stable", channelStock: { DTC: 800, B2B: 400 }, restockDays: { DTC: 35, B2B: 45 } },
      { id: "SKU-004", name: "Retinol Night Cream 50ml", stock: 780, status: "healthy", velocity: 30, dos: 26, demandTrend: "growing", channelStock: { DTC: 346, TikTok: 234, B2B: 200 }, restockDays: { DTC: 26, TikTok: 19, B2B: 38 } },
    ],
  },
];

export const CHANNEL_META = {
  Shopee: { color: "#f97316", bg: "bg-orange-50", text: "text-orange-700", border: "border-orange-200", dot: "#f97316" },
  TikTok: { color: "#ec4899", bg: "bg-pink-50", text: "text-pink-700", border: "border-pink-200", dot: "#ec4899" },
  DTC: { color: "#3b82f6", bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200", dot: "#3b82f6" },
  Lazada: { color: "#a855f7", bg: "bg-violet-50", text: "text-violet-700", border: "border-violet-200", dot: "#a855f7" },
  B2B: { color: "#0d9488", bg: "bg-teal-50", text: "text-teal-700", border: "border-teal-200", dot: "#0d9488" },
};

// ─── Time-Series Generators ─────────────────────────────────────────────────

const hashStr = (str) => {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash) + str.charCodeAt(i);
    hash = hash & hash;
  }
  return Math.abs(hash);
};

const seededRandom = (seed) => {
  let s = (seed % 2147483647) || 1;
  if (s <= 0) s += 2147483646;
  return () => {
    s = (s * 16807) % 2147483647;
    return (s - 1) / 2147483646;
  };
};

const channelShare = { Shopee: 0.35, TikTok: 0.30, DTC: 0.15, Lazada: 0.12, B2B: 0.08 };
const fmtDate = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const TODAY = new Date(2025, 2, 1); // Mar 1, 2025 — wireframe reference date

export const generateDailySales = (skuId, channel, days = 90, trend = "stable") => {
  const rng = seededRandom(hashStr(skuId + channel + "sales"));
  const skuData = SKU_DATA.find((s) => s.id === skuId);
  const base = (skuData ? skuData.velocity : 50) * (channelShare[channel] || 0.2);
  const trendFactor = trend === "growing" ? 0.008 : trend === "slowing" ? -0.006 : 0.001;
  const weekday = [1.0, 0.92, 0.88, 0.90, 0.96, 1.15, 1.12];

  const data = [];
  for (let i = days; i >= 1; i--) {
    const d = new Date(TODAY);
    d.setDate(d.getDate() - i);
    const t = base * trendFactor * (days - i);
    const noise = (rng() - 0.5) * base * 0.35;
    const units = Math.max(1, Math.round((base + t + noise) * weekday[d.getDay()]));
    data.push({ date: fmtDate(d), units });
  }
  return data;
};

export const generateForecast = (skuId, channel, days = 90, trend = "stable") => {
  const rng = seededRandom(hashStr(skuId + channel + "forecast"));
  const history = generateDailySales(skuId, channel, 14, trend);
  const avg = history.reduce((a, d) => a + d.units, 0) / history.length;
  const trendFactor = trend === "growing" ? 0.01 : trend === "slowing" ? -0.008 : 0.002;

  const data = [];
  for (let i = 0; i < days; i++) {
    const d = new Date(TODAY);
    d.setDate(d.getDate() + i);
    const t = avg * trendFactor * i;
    const noise = (rng() - 0.5) * avg * 0.2;
    const units = Math.max(1, Math.round(avg + t + noise));
    const confidence = Math.min(0.45, 0.08 + i * 0.004);
    data.push({
      date: fmtDate(d),
      units,
      upper: Math.round(units * (1 + confidence)),
      lower: Math.max(1, Math.round(units * (1 - confidence))),
    });
  }
  return data;
};
